import { NavLink, useLocation } from 'react-router-dom';
import Facebook from "../../Assets/LOGO/Facebook.png";
import FooterLogo from "../../Assets/LOGO/Footer_New_Logo.png";
import Instagram from "../../Assets/LOGO/IG.png";
import LinkedIn from "../../Assets/LOGO/LIN.png";
import "../CSS/Footer.css";

const Footer = () => {
    const location = useLocation();
    // Default Social Links
    const defaultLinks = {
        instagram: "https://www.instagram.com/holisticlearning_/",
        linkedin: "https://in.linkedin.com/company/holistic-learning-in",
    };
    // Student pages / thank-you pages
    const studentPages = [
        "/career-internship-success/",
        "/resource-vault-success",
        "/pre-departure-success/",
        "/peer-mentorship-success/",
        "/academic-readiness-success/",
        "/gulf-students-success",
        "/gulf-students",
        "/gulf-students/pre-departure",
        "/gulf-students/academic-readiness",
        "/gulf-students/mentorship",
        "/gulf-students/career-prep",
        "/gulf-students/resource-vault"
    ];
    // Student specific social links (Instagram + LinkedIn change if needed)
    const studentLinks = {
        instagram: "https://www.instagram.com/hl_gulf_students/",
        linkedin: "https://www.linkedin.com/showcase/holistic-learning-for-gulf-students/about/?viewAsMember=true",
    };
    // Determine which links to use
    const isStudentPage = studentPages.includes(location.pathname);
    const socialLinks = isStudentPage ? studentLinks : defaultLinks;
    // Facebook URL for selected pages
    const facebookUrl = "https://www.facebook.com/profile.php?id=61580769146409";

    // Check if current page is in facebookPages
    const showFacebook = studentPages.includes(location.pathname);
    return (
        <>
            <footer>
                <section className="footer-section-of-hl">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="footer-logo-and-content">
                                    <div className="footer-logo">
                                        <NavLink to={"/"} className="href"><img src={FooterLogo} alt="Holistic Learning Bangalore" className='img-fluid' /></NavLink>
                                    </div>
                                    <div className="footer-content">
                                        <p className="footer-para">At Holistic Learning, we write - be it academic content, a blog, a website content, technical aspects, creative elements or any other form.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 footer-nav-menu-and-social-icon">
                                {/* <div className="footer-nav-menu-and-social-icon"> */}
                                <div className="footer-nav-menu-main-div">
                                    <div className="first-three-footer-menu">
                                        <ul>
                                            <li><NavLink to={"/our-team"} className="href">Our Team</NavLink></li>
                                            <li><NavLink to={"/careers"} className="href">Careers</NavLink></li>
                                        </ul>
                                    </div>
                                    <div className="last-three-footer-menu">
                                        <ul>
                                            <li><NavLink to={"/events"} className="href">Events</NavLink></li>
                                            <li><NavLink to={"/touchbase"} className="href">Touch Base</NavLink></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="footer-social-media-icon-div">
                                    <ul>
                                        <li><a href={socialLinks.instagram} className="href" target='_blank' rel="noopener noreferrer"><img src={Instagram} alt="Instagram" /></a></li>
                                        <li><a href={socialLinks.linkedin} target='_blank' rel="noopener noreferrer" className="href"><img src={LinkedIn} alt="LinkedIn" /></a></li>
                                        {/* Facebook icon only for selected pages */}
                                        {showFacebook && (
                                            <li>
                                                <a href={facebookUrl} target='_blank' rel="noopener noreferrer" className="href">
                                                    <img src={Facebook} alt="Facebook" />
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                                {/* </div> */}
                            </div>
                            <div className="col-md-12 footer-last-div-content">
                                <p>© Copyright 2023, All Rights Reserved by <span><NavLink to={"/"} className="href">HOLISTICLEARNING.COM</NavLink></span></p>
                            </div>
                        </div>
                    </div>
                </section>
            </footer>
        </>
    )
}

export default Footer;